import { IinitialMainContactsState } from 'interfaces/mainContacts.interface';
import * as MainContactsTypes from './mainContacts.types';
import {
  IcreateMainContactAPIResponseBody,
  IgetMainContactsAPIResponseItemContact,
} from 'api/endpoints/mainContacts/mainContacts.response.interface';
import { InotificationsTypesItem } from 'interfaces/notifications.interface';

export type TmainContactsDispatchReducer =
  | {
      type: typeof MainContactsTypes.GET_MAIN_CONTACTS;
      payload: Array<IgetMainContactsAPIResponseItemContact>;
    }
  | {
      type: typeof MainContactsTypes.SELECT_CONTACT;
      payload: IgetMainContactsAPIResponseItemContact | null;
    }
  | {
      type: typeof MainContactsTypes.CREATE_CONTACT;
      payload: IgetMainContactsAPIResponseItemContact;
    }
  | {
      type: typeof MainContactsTypes.UPDATE_CONTACT;
      payload: {
        id: string;
        contact: IcreateMainContactAPIResponseBody;
        notifications: Array<InotificationsTypesItem>;
      };
    }
  | {
      type: typeof MainContactsTypes.REMOVE_CONTACT;
      payload: string;
    }
  | {
      type: typeof MainContactsTypes.SET_IS_LOADING_CONTACTS;
      payload: boolean;
    };

export default function mainContactsReducer(
  state: IinitialMainContactsState,
  action: TmainContactsDispatchReducer
) {
  const { type, payload } = action;

  switch (type) {
    case MainContactsTypes.GET_MAIN_CONTACTS: {
      const getMainContacts: IinitialMainContactsState = {
        ...state,
        contacts: payload,
      };
      return getMainContacts;
    }

    case MainContactsTypes.SELECT_CONTACT: {
      const selectContact: IinitialMainContactsState = {
        ...state,
        contactSelected: payload,
      };
      return selectContact;
    }

    case MainContactsTypes.CREATE_CONTACT: {
      const createContact: IinitialMainContactsState = {
        ...state,
        contacts: [...state.contacts, payload],
      };
      return createContact;
    }

    case MainContactsTypes.UPDATE_CONTACT: {
      const updateContact: IinitialMainContactsState = {
        ...state,
        contacts: state.contacts.map((contactItem) => {
          const updatedContact: IgetMainContactsAPIResponseItemContact = {
            ...contactItem,
            contact: {
              ...contactItem.contact,
              ...payload.contact,
            },
            company_tenant_notifications: payload.notifications,
          };

          return contactItem.contact.id === payload.id ? updatedContact : contactItem;
        }),
      };
      return updateContact;
    }

    case MainContactsTypes.REMOVE_CONTACT: {
      const removeContact: IinitialMainContactsState = {
        ...state,
        contacts: state.contacts.filter((contact) => contact.contact.id !== payload),
      };
      return removeContact;
    }

    case MainContactsTypes.SET_IS_LOADING_CONTACTS: {
      const setIsLoadingContacts: IinitialMainContactsState = {
        ...state,
        isLoadingContacts: payload,
      };
      return setIsLoadingContacts;
    }

    default:
      return state;
  }
}
